export const StringHelper = {
    generateUUID() {
        const TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        const HEX_BASE = 16;
        const UUID_VERSION = 4;
        const VARIANT_MASK = 0x3;
        const VARIANT_VALUE = 0x8;
        return TEMPLATE.replace(/[xy]/g, function (c) {
            const randomHex = Math.floor(Math.random() * HEX_BASE);
            if (c === 'x') {
                return randomHex.toString(HEX_BASE);
            }
            else if (c === 'y') {
                return ((randomHex & VARIANT_MASK) | VARIANT_VALUE).toString(HEX_BASE);
            }
            else {
                return UUID_VERSION.toString(HEX_BASE);
            }
        });
    },
    normalizeText(text) {
        return text
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .toLowerCase();
    }
};
